import { render } from "./PlotOrderIframe.vue?vue&type=template&id=3325dd00&ts=true"
import script from "./PlotOrderIframe.ts?vue&type=script&lang=ts&external"
export * from "./PlotOrderIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__